import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { authAPI } from 'Utils/api';
import styled from 'styled-components';

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const LoginCard = styled(Card)`
  width: 400px;
  max-width: calc(100% - 32px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  .ant-card-head {
    background: #1890ff;
    color: white;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
`;

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      const response = await authAPI.login(values.email, values.password);
      const { accessToken, employee } = response.data;

      localStorage.setItem('admin_token', accessToken);
      localStorage.setItem('admin_user', JSON.stringify(employee));
      message.success('Login erfolgreich!');
      const from = (location.state as any)?.from;
      navigate(from ? `${from.pathname}${from.search}` : '/dashboard', { replace: true });
    } catch (error: any) {
      message.error(error.response?.data?.message || 'Login fehlgeschlagen!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContainer>
      <LoginCard title="MR Luxury Watches - Admin">
        <Form name="login" onFinish={onFinish} autoComplete="off">
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Bitte Email/Username eingeben!' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="system_admin"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Bitte Passwort eingeben!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Passwort"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              Anmelden
            </Button>
          </Form.Item>
        </Form>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginPage;
